import { render, staticRenderFns } from "./ListadoClientesExtraCost.vue?vue&type=template&id=61406ab3"
import script from "./ListadoClientesExtraCost.vue?vue&type=script&lang=js"
export * from "./ListadoClientesExtraCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports